import axios from "axios";

import { MAX_ELEMENTS_PER_PAGE } from "../constants/constants.ts";
import { MailSearchType } from "../enums/MailSearchType.ts";
import { CreateMailDto } from "../models/CreateMailDto.ts";

export function useMailService() {
  const mailsApiUrl = Config.apiBaseUrl + "/mails";

  async function fetchMails(
    page: number,
    searchType: MailSearchType,
    search: string,
    mailStatus?: string[]
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      size: MAX_ELEMENTS_PER_PAGE.toString(),
      searchType: searchType.toUpperCase(),
      search: search
    });

    if (mailStatus && mailStatus.length > 0) {
      mailStatus.forEach((status) => params.append("mailStatus", status));
    }

    const response = await axios.get(`${mailsApiUrl}?${params.toString()}`);
    return response.data;
  }

  async function createMail(mailData: CreateMailDto) {
    await axios.post(`${mailsApiUrl}`, mailData);
  }

  return {
    fetchMails,
    createMail
  };
}
